// removed by extract-text-webpack-plugin
module.exports = {"data-selector":"data-selector__data-selector","modal":"data-selector__modal","modal-close":"data-selector__modal-close","tab-list":"data-selector__tab-list","tab-panel":"data-selector__tab-panel","tab":"data-selector__tab","react-tabs":"data-selector__react-tabs","dataset-list":"data-selector__dataset-list","dataset-list-element":"data-selector__dataset-list-element","element-selected":"data-selector__element-selected","upload-panel":"data-selector__upload-panel","paste-panel":"data-selector__paste-panel","url-panel":"data-selector__url-panel","dropzone-target":"data-selector__dropzone-target"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-selector/data-selector.scss
// module id = 1214
// module chunks = 0